import { useState } from "react"
import Swal from "sweetalert2"
import { GET, POST, PUT, DELETE } from "../../../../services/api"
import { TableParams } from "../../dinamicPage/dinamyc-pages.types"
import { AggregatorPublicity, CreateAgregatorPublicityDto, typeBannerHotel, UpdateAgregatorPublicityDto } from "../agregador-publicity.type"
import { validateForm } from "./helper.factory"

const URL = 'aggregator-publicity'


export function useAgregadorPublicity(type: typeBannerHotel) {
    const [aggregatorPublicity, setAggregatorPublicity] = useState<AggregatorPublicity[]>([])
    const [loading, setLoading] = useState(false)
    const [tableLoading, setTableLoading] = useState(false)

    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 10,
        total: 0,
        pageSizes: [10, 25, 50, 100],
    })
    const [sorting, setSorting] = useState({
        field: 'id',
        direction: 'asc' as 'asc' | 'desc',
    })
    const [searchTerm, setSearchTerm] = useState('')



    const handleDataChange = async (params: {
        page: number
        pageSize: number
        search: string
        sorting?: { field: string; direction: 'asc' | 'desc' }
        filters?: any
    }) => {
        setPagination((prev) => ({ ...prev, page: params.page, pageSize: params.pageSize }))
        if (params.sorting) setSorting(params.sorting)
        setSearchTerm(params.search)
        return await getAggregatorPublicity(params)
    }


    const handlePaginationChange = async (newPagination: any) => {
        setPagination(newPagination)
        return await getAggregatorPublicity({
            page: newPagination.page,
            pageSize: newPagination.pageSize,
            search: searchTerm,
            sorting: sorting.field ? sorting : { field: 'id', direction: 'asc' },
        })
    }

    const handleSortingChange = async (newSorting: any) => {
        setSorting(newSorting)
        return await getAggregatorPublicity({
            page: pagination.page,
            pageSize: pagination.pageSize,
            search: searchTerm,
            sorting: newSorting,
        })
    }

    async function getAggregatorPublicity(params?: TableParams) {
        try {
            setTableLoading(true)
            const currentPage = params?.page || pagination.page
            const currentPageSize = params?.pageSize || pagination.pageSize
            const currentSearch = params?.search || searchTerm
            const currentSorting = params?.sorting || sorting

            const query = `?field=${currentSorting.field}&order=${currentSorting.direction.toUpperCase()}&page=${currentPage}&take=${currentPageSize}&search=${currentSearch}`



            const request = await GET(`${URL}/${type}${query}`)
            console.log('[getAggregatorDinamicPage] Resposta da API:', request)
            if (!request.data) {
                console.warn('[getAggregatorDinamicPage] Nenhum dado retornado da API!')
            }

            setAggregatorPublicity(request.data)

            if (request.meta) {
                const paginagionInfo = {
                    total: request.meta.itemCount,
                    page: currentPage,
                    pageSize: currentPageSize,
                }
                setPagination((prev) => ({
                    ...prev,
                    ...paginagionInfo,
                }))
                console.log('[getAggregatorDinamicPage] Paginação atualizada:', paginagionInfo)
            }
            return request.data
        } catch (error) {
            console.log('[getAggregatorDinamicPage] Erro:', error)
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Um erro ocorreu ao filtrar',
            })
            return []
        } finally {
            setTableLoading(false)
        }
    }

    async function getPublicityHighLightById(id: number) {
        try {
            const request = await GET(`${URL}/${id}`)

            return request
        } catch (error) {
            console.log('[getAggregatorDinamicPage] Erro:', error)
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Um erro ocorreu ao filtrar',
            })
            return []
        } finally {
            setTableLoading(false)
        }
    }

    async function createPublicityHighLight(data: CreateAgregatorPublicityDto) {
        try {

            const isValid = validateForm(data)
            if (!isValid) return

            setLoading(true)
            const request = await POST(`${URL}`, data)
            console.log('[createAggregatorClassification] Resposta da API:', request)
            if (request.data) {
                Swal.fire({
                    icon: 'success',
                    title: 'Sucesso',
                    text: 'Página criada com sucesso!',
                })
                await getAggregatorPublicity()
            }
        } catch (error) {
            console.log('[createAggregatorClassification] Erro:', error)
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Um erro ocorreu ao criar a Página',
            })
        } finally {
            setLoading(false)
        }
    }

    async function updatePublicityHighLight(id: number, data: UpdateAgregatorPublicityDto) {
        try {
            const isValid = validateForm(data as CreateAgregatorPublicityDto)
            if (!isValid) return
            setLoading(true)
            const request = await PUT(`${URL}/${id}`, data)
            console.log('[updateAggregatorClassification] Resposta da API:', request)
            if (request.data) {
                Swal.fire({
                    icon: 'success',
                    title: 'Sucesso',
                    text: 'Página atualizada com sucesso!',
                })
                await getAggregatorPublicity()
            }
        } catch (error) {
            console.log('[updateAggregatorClassification] Erro:', error)
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Um erro ocorreu ao atualizar a Página',
            })
        } finally {
            setLoading(false)
        }
    }

    async function deletePublicityHighLight(id: number) {
        try {
            setLoading(true)
            const request = await DELETE(`${URL}/${id}`)
            console.log('[deleteAggregatorClassification] Resposta da API:', request)
            if (request) {
                Swal.fire({
                    icon: 'success',
                    title: 'Sucesso',
                    text: 'Página deletada com sucesso!',
                })
                await getAggregatorPublicity()
            }
        } catch (error) {
            console.log('[deleteAggregatorClassification] Erro:', error)
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Um erro ocorreu ao deletar a Página',
            })
        } finally {
            setLoading(false)
        }
    }

    return {
        aggregatorPublicity,
        loading,
        setLoading,
        tableLoading,
        pagination,
        sorting,
        searchTerm,
        handleDataChange,
        handlePaginationChange,
        handleSortingChange,
        setTableLoading,
        deletePublicityHighLight,
        updatePublicityHighLight,
        createPublicityHighLight,
        getPublicityHighLightById,
        getAggregatorPublicity
    }
}
